import { render, staticRenderFns } from "./RecordDeleteButton.vue?vue&type=template&id=64936c94"
import script from "./RecordDeleteButton.vue?vue&type=script&lang=js"
export * from "./RecordDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports